import host from '../host';
import get_size from './get_size';

export default async function save_size(size){
  let exists = await get_size();
  let customer = window.customerId;
  if(customer && !exists){
    let response = await fetch(
      host + `/api/customer_sizes/`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer: window.customerId,
          size: size,
        })
      }
    );
    if(response.ok){
      return await response.json();
    }
  } else if(window.customerId) {
    let response = await fetch(
      host + `/api/customer_sizes/${window.customerId}/`,
      {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer: window.customerId,
          size: size,
        })
      }
    );
    if(response.ok){
      return await response.json();
    }
  }
}
